module.exports = __webpack_public_path__ + "static/case_study_turystyczna_front-2980d1b18307563b9d6f4165e036e0c8.png";